import { defineComponent as _defineComponent } from 'vue'
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import { ref, watch } from 'vue';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { indexedWidgetDefinitions } from '@/utils/misc';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendOverview',
  props: {
    selectedDevices: null,
    selectedTimespan: null,
    selectedShifts: null,
    selectedTimeAxisSpan: null
  },
  setup(__props: any) {

const props = __props as {
  selectedDevices: string[];
  selectedTimespan: FilterTimeSpanEnum;
  selectedShifts: number[];
  selectedTimeAxisSpan: FilterTimeAxisSpanEnum;
};



const widgetDefinitions = ref<WidgetDefinition[]>(createWidgetDefinitions());

const gridLayout = availableDashboardLayouts[DashboardLayout.TwoByThree];

function createWidgetDefinitions(): WidgetDefinition[] {
  return indexedWidgetDefinitions([
    new WidgetDefinition(
      WidgetEnum.BendingAvailability,
      props.selectedDevices,
      props.selectedTimespan,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
    new WidgetDefinition(
      WidgetEnum.BendStatus,
      props.selectedDevices,
      undefined,
      [],
    ),
    new WidgetDefinition(
      WidgetEnum.BendingTimeBetweenBend,
      props.selectedDevices,
      props.selectedTimespan,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
    new WidgetDefinition(
      WidgetEnum.BendingPerformancePart,
      props.selectedDevices,
      props.selectedTimespan,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
    new WidgetDefinition(
      WidgetEnum.BendingPerformance,
      props.selectedDevices,
      props.selectedTimespan,
      props.selectedShifts,
    ),
    new WidgetDefinition(
      WidgetEnum.BendingTopParts,
      props.selectedDevices,
      props.selectedTimespan,
      props.selectedShifts,
      undefined,
      props.selectedTimeAxisSpan,
    ),
  ]);
}

function replaceWidgetDefinition(
  index: number,
  widgetDefinition: WidgetDefinition,
) {
  widgetDefinitions.value.splice(index, 1, widgetDefinition);
}

function updateWidgetDefinitions() {
  widgetDefinitions.value = widgetDefinitions.value.map((widgetDefinition) =>
    widgetDefinition.getCopy({
      deviceId: props.selectedDevices,
      timeFilter: props.selectedTimespan,
      shifts: props.selectedShifts,
      axisSpan: props.selectedTimeAxisSpan,
    }),
  );
}

watch(
  () => [
    props.selectedDevices,
    props.selectedTimespan,
    props.selectedShifts,
    props.selectedTimeAxisSpan,
  ],
  () => {
    updateWidgetDefinitions();
  },
);

return { __sfc: true,props, widgetDefinitions, gridLayout, createWidgetDefinitions, replaceWidgetDefinition, updateWidgetDefinitions, LayoutGrid, WidgetContainer }
}

})